'use client'

import React from 'react'

import type { HeaderBlock as HeaderBlockProps } from '@/payload-types'

import { SectionWrapper } from '@/components/SectionWrapper'
import SectionHeader from '@/components/ui/SectionHeader'
import { Links } from '@/components/Links/Component'
import { normalizeSectionSettings } from '@/utilities/sectionSettings'

export const HeaderBlockClient: React.FC<HeaderBlockProps> = ({
  infoTagText,
  title,
  subtitle,
  links,
  settings,
}) => {
  const normalizedSettings = normalizeSectionSettings(settings)

  return (
    <SectionWrapper settings={normalizedSettings} className="overflow-hidden">
      <SectionHeader
        infoTagText={infoTagText || ''}
        title={title}
        className='mb-0 md:mb-0'
        subtitle={subtitle || undefined}
      />
      {links && links.length > 0 && (
        <div className="mt-6 md:mt-8">
          <Links links={links} className="flex flex-col sm:flex-row items-start gap-6 md:gap-12" />
        </div>
      )}
    </SectionWrapper>
  )
}
